<template>
  <div class="flex flex-col-reverse items-center md:flex-row items-center my-1 -mx-1">
    <div class="mx-1.5 py-1">
      <form
        class="review-form"
        name="cancellation_review_anonymous"
        @click.prevent=""
      >
        <adivare-review-stars
          v-model="rating"
          :default-rating="defaultRating"
          @star-clicked="submitForm"
        />
      </form>
    </div>
    <div class="flex items-center mx-1.5 py-1 md:mt-1.5 text-sm">
      <p class="font-bold py-px px-2 rounded-full text-white bg-rating">{{ $t('messages_nl.global.reviewRating', { averageRating } ) }}</p>
      <a
        href="#review-list-container"
        class="pl-2 hover:underline underline-offset-2 whitespace-nowrap"
      >
        {{ reviewCountMessage }}
      </a>
      <a
        href="#review-form-container"
        class="pl-2 hover:underline underline-offset-2 whitespace-nowrap"
      >
        ({{ $t('messages_nl.cancellation.view.cancellationReview.writeReview') }})
      </a>
    </div>
  </div>
</template>

<script>
import AdivareReviewStars from "../../../components/form/review-stars";
import client from '../../../axios-client';
import { anonymousReviewKey } from "../../../../js/util/cookie";
import readCookie from "../../../../js/util/cookie"

export default {
  name: "adivare-anonymous-review-form",
  components: { AdivareReviewStars },
  props: {
    cancellationId: {
      required: true,
    },
    defaultRating: {
      type: Number,
      required: true,
      validator: value => value <= 5 && value >= 0,
    },
    totalReviews: {
      type: Number,
      required: true,
      validator: value => value > 0,
    },
  },
  data() {
    return {
      rating: null,
      hasSubmitted: false,
      updatedTotalReviews: this.totalReviews,
    };
  },
  computed: {
    reviewCountMessage() {
      return this.updatedTotalReviews > 1
        ? this.$t('messages_nl.cancellation.view.cancellationReview.multipleReviews', {total: this.updatedTotalReviews})
        : this.$t('messages_nl.cancellation.view.cancellationReview.singleReview');
    },
    averageRating() {
      try {
        return Math.round(this.defaultRating);
      } catch (Error) {
        // Validator will fail, but not sure if that emits an error.
        // Either way, uncaught errors in computed properties cause vue to crash.
        console.error(Error.message);
      }
    },
  },
  methods: {
    submitForm() {
      if (this.hasSubmitted) {
        return;
      }
      this.hasSubmitted = true;
      try {
        readCookie(anonymousReviewKey(this.cancellationId));
        this.$store.dispatch('addFlash', {
          message: this.$t('messages_nl.form.review.reviewNotUnique'),
          type: 'danger',
        });
      } catch (error) {
        client.fetchIp()
          .then(response => {
            client.submitAnonymousReview(this.cancellationId, {
              rating: this.rating,
              ipAddress: response.data.ip,
              cancellationId: this.cancellationId,
            })
            .then(() => {
              this.$store.dispatch('addFlash', {
                type: 'success',
                message: this.$t('messages_nl.form.reviewAnonymous.success'),
              }).then(() => {
                ++this.updatedTotalReviews;
                scrollBy(0, -120);
              });
            })
            .catch(error => console.error(error));
        })
        .catch(error => console.error(error));
      }
    },
  },
}
</script>
